import React__default from 'react';
import { Button } from 'react-aria-components';
import { RightChevron } from '../icons/RightChevron.js';
import './Breadcrumbs.scss';

const Breadcrumbs = ({ items, currentId = items[items.length - 1].id, }) => (React__default.createElement("ol", { className: 'breadcrumbs--rev' }, items.map((item, index) => {
    const isCurrent = item.id === currentId;
    const currentIndex = items.findIndex((item) => item.id === currentId);
    const isAfterCurrent = index > currentIndex;
    return (React__default.createElement(React__default.Fragment, { key: index },
        React__default.createElement("li", { className: 'breadcrumb-item--rev' },
            React__default.createElement(Button, { "data-current": isCurrent, isDisabled: item.isDisabled || isCurrent || isAfterCurrent, onClick: !item.isDisabled && item.onActivate ? item.onActivate : undefined }, item.label),
            index !== items.length - 1 && React__default.createElement(RightChevron, { "aria-hidden": 'true' }))));
})));

export { Breadcrumbs };
//# sourceMappingURL=Breadcrumbs.js.map
